import { takeLatest, select, call } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
// import { OVERLAY_SPINNER, OVERLAY_TEXT } from "../../constants/overlayTypes";
import { FLYER_DATA, NEWSPAPER_DATA, PRINT_GENERAL_SETTINGS, WEEK_PROGRAM_FLYER_DATA } from "../../constants/state";
import getData from "../../functions/getData";
import { updatePrintCall } from "../../apis/printApi/apiCalls";
import { putSuccess, putError } from '../helpers'
import authUser from "../../apis/wpApi/authUser";


const getFlyerData = state => ({
    flyerData: getData(state, FLYER_DATA).toJS(),
    weekProgramFlyerData: getData(state, WEEK_PROGRAM_FLYER_DATA).toJS(),
    newspaperData: getData(state, NEWSPAPER_DATA),
    generalSettingsData: getData(state, PRINT_GENERAL_SETTINGS)
})

function* updateData(action) {
    try {
        // yield call(overlaySetRequestType, actionTypes.PRINT_DATA_UPDATE_REQUEST)
        // yield call(overlaySetOverlayType, OVERLAY_SPINNER)

        const apiKey = yield call(authUser.getToken)
        const { flyerData, weekProgramFlyerData, newspaperData, generalSettingsData } = yield select(getFlyerData)

        if(!flyerData) {
            throw new Error('No flyer data') 
        }

        if(!weekProgramFlyerData) {
            throw new Error('No weekProgramFlyer data') 
        }

        if(!newspaperData) {
            throw new Error('No newspaperData data') 
        }

        if(!generalSettingsData) {
            throw new Error('No generalSettingsData data') 
        }

        const response = yield call(updatePrintCall, apiKey, {flyer: flyerData, weekProgramFlyer: weekProgramFlyerData, newspaper: newspaperData, generalSettings: generalSettingsData})

        if(!response || !response.status || 200 !== response.status || !response.data || !response.data.flyer || !response.data.weekProgramFlyer) {
            throw new Error('Could not update data')
        } else {
            yield putSuccess(actionTypes.PRINT_DATA_UPDATE_SUCCESS, {flyer: response.data.flyer, weekProgramFlyer: response.data.weekProgramFlyer, newspaper: response.data.newspaper, generalSettings: response.data.generalSettings})


            // yield put({
            //     type: actionTypes.POST_POSTER_PDF_COMBINED_REQUEST,
            //     meta: {},
            //     payload: action.payload
            // })

            // const result = yield take([actionTypes.POST_POSTER_PDF_COMBINED_SUCCESS, actionTypes.POST_POSTER_PDF_COMBINED_ERROR])
            
            // if(result.type === actionTypes.POST_POSTER_PDF_COMBINED_ERROR) {
            //     throw new Error(result.payload.errorMessage)
            // } else {
            //     yield putSuccess(actionTypes.PRINT_DATA_UPDATE_SUCCESS, {flyer: response.data.flyer})
            //     yield call(overlaySetOverlayType, OVERLAY_TEXT)
            // }
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.PRINT_DATA_UPDATE_ERROR, e.message)
        // yield call(overlaySetOverlayType, OVERLAY_TEXT)
    }
}

function* watchPrintUpdateRequest() {
    yield takeLatest(actionTypes.PRINT_DATA_UPDATE_REQUEST, updateData);
}

export default watchPrintUpdateRequest


/// UI_GENERAL_REQUEST_OVERLAY_RESET
// uiRequestOverlayReset
